var _circle, _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrempie(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1302 52.4478C43.1302 56.3979 46.2426 59.6129 50.0651 59.6129C53.8876 59.6129 57 56.3979 57 52.4478C57 49.2633 53.0222 42.9803 51.8016 41.1328C51.0332 39.9622 49.097 39.9622 48.3286 41.1328C47.1081 42.9803 43.1302 49.2633 43.1302 52.4478Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2517 36.4273C44.7202 38.3843 37.9847 44.2411 34.4815 47.2409C33.2347 48.3123 31.4525 48.3123 30.2057 47.2409C26.7024 44.2411 19.9737 38.3843 18.4355 36.4273C16.091 33.4489 15 30.6133 15 27.5278C15 24.5137 15.9758 21.7424 17.7511 19.7139C19.5536 17.6641 22.0133 16.5284 24.6899 16.5284C26.6957 16.5284 28.5252 17.1998 30.1379 18.514C30.9782 19.2068 31.7236 20.0211 32.3402 20.9424C32.9636 20.0282 33.7022 19.2068 34.5425 18.514C36.1552 17.1927 37.9915 16.5284 39.9973 16.5284C42.6806 16.5284 45.1404 17.6641 46.9361 19.7139C48.7046 21.7424 49.6872 24.5065 49.6872 27.5278C49.694 30.6133 48.603 33.4489 46.2517 36.4273Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.881 49.9117C46.881 51.825 48.3539 53.3823 50.1628 53.3823C51.9718 53.3823 53.4447 51.825 53.4447 49.9117C53.4447 48.3691 51.5622 45.3257 50.9846 44.4309C50.621 43.8638 49.7047 43.8638 49.3411 44.4309C48.7635 45.3257 46.881 48.3691 46.881 49.9117Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.694,
    height: 36.5693,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrempie);
export default __webpack_public_path__ + "static/media/crempie.801ad1401dc19d9559cd587273d9bac7.svg";
export { ForwardRef as ReactComponent };